/**
 * @module
 * @name NumberSelector
 */
export default {
  name: 'numberSelector',

  /**
   * @function
   * @property {Number} currentValue Value selected
   */
  data: function() {
    return {
      currentValue: this.defaultNumberSelected || this.min
    }
  },

  /**
   * @property {Number} min Min Value allowed
   * @property {Number} max Max Value allowed
   */

  props: {
    min: {
      type: Number,
      required: false,
      default: 1
    },
    max: {
      type: Number,
      required: true,
      default: 1
    },
    defaultNumberSelected: {
      type: Number,
      required: false,
      default: 0
    }
  },

  computed: {
    isLeftArrowEnabled: function() {
      return this.currentValue > this.min
    },

    isRightArrowEnabled: function() {
      return this.currentValue < this.max
    }
  },

  methods: {
    getArrowColor: function(enabled) {
      if (enabled) {
        return 'white'
      }

      return 'gray'
    },

    clickLeftArrow: function() {
      if (this.currentValue > this.min) {
        --this.currentValue
        this.$emit('change', this.currentValue)
      }
    },

    clickRightArrow: function() {
      if (this.currentValue < this.max) {
        ++this.currentValue
        this.$emit('change', this.currentValue)
      }
    }
  }
}
